import "jquery-validation";
import "jquery-validation/dist/localization/messages_zh_TW";
import "jquery-validation/dist/additional-methods";

/**
 * 將傳進來的 form 做統一的 validation 設定
 *
 * @param form Form
 * @param validateParams Validate plugin 的參數
 * @param beforeObserver form檢查完畢,送交form之前要呼叫的事件
 */
window.observeForm = function (form, validateParams, beforeObserver) {
    validateParams.submitHandler = function (form) {
        if (typeof beforeObserver === "function") {
            beforeObserver(form);
        } // end of if
    };

    // 將 form 跟 plugin 綁定
    $(form).validate(validateParams);
};

// ----------------------------------------------------------------
//                     統一編號驗證方法
// ----------------------------------------------------------------
/**
 * 驗證台灣統一編號是否有效
 * 
 * @param taxId 統一編號 (8位數字)
 * @returns {boolean} 是否為有效的統一編號
 */
window.validateTaxId = function (taxId) {
    
    // 必須是 8 位數字
    if (!/^\d{8}$/.test(taxId)) {
        return false;
    }
    
    // 權重陣列
    const weights = [1, 2, 1, 2, 1, 2, 4, 1];
    let sum = 0;
    
    // 計算加權總和
    for (let i = 0; i < 8; i++) {
        let digit = parseInt(taxId[i]);
        let product = digit * weights[i];
        
        // 如果乘積為兩位數，將十位數和個位數相加
        if (product >= 10) {
            product = Math.floor(product / 10) + (product % 10);
        }
        
        sum += product;
    }
    
    // 檢查總和是否能被 5 整除
    if (sum % 5 === 0) {
        return true;
    }
    
    // 特殊規則：當第七位數字為 7 時，總和加 1 後能被 5 整除也算有效
    if (taxId[6] === '7' && (sum + 1) % 5 === 0) {
        return true;
    }
    
    return false;
};

// ----------------------------------------------------------------
//                     密碼強度驗證方法
// ----------------------------------------------------------------
/**
 * 驗證密碼強度（8 至 20 個字元，須包含英文大小寫及數字）
 * 
 * @param password 密碼
 * @returns {boolean} 是否為有效的密碼
 */
window.validatePassword = function (password) {
    // 去除前後空白
    password = (password || "").trim();
    
    // 長度必須在 8 到 20 個字元之間
    if (password.length < 8 || password.length > 20) {
        return false;
    }
    
    // 必須包含至少一個小寫英文字母
    if (!/[a-z]/.test(password)) {
        return false;
    }
    
    // 必須包含至少一個大寫英文字母
    if (!/[A-Z]/.test(password)) {
        return false;
    }
    
    // 必須包含至少一個數字
    if (!/[0-9]/.test(password)) {
        return false;
    }
    
    return true;
};

// ----------------------------------------------------------------
//   讓 validator 可以判斷同個名稱的 input
//    ex. <input type="hidden" name="names[]" value="">
//    原本的只會判斷第一個欄位，就會通過了
// ----------------------------------------------------------------
$.validator.prototype.checkForm = function () {
    //overridden in a specific page
    this.prepareForm();

    for (
        var i = 0, elements = (this.currentElements = this.elements());
        elements[i];
        i++
    ) {
        if (
            this.findByName(elements[i].name).length !== undefined &&
            this.findByName(elements[i].name).length > 1
        ) {
            for (
                var cnt = 0;
                cnt < this.findByName(elements[i].name).length;
                cnt++
            ) {
                this.check(this.findByName(elements[i].name)[cnt]);
            }
        } else {
            this.check(elements[i]);
        }
    }

    return this.valid();
};

// ----------------------------------------------------------------
//                          設定預設的功能
// ----------------------------------------------------------------
// 添加統一編號驗證規則
$.validator.addMethod(
    "taxId",
    function (value, element) {
        // 如果欄位為空，讓 required 規則處理
        if (!value || value.trim() === "") {
            return true;
        }
        return window.validateTaxId(value);
    },
    "統一編號格式不正確"
);

// 添加密碼強度驗證規則
$.validator.addMethod(
    "passwordStrength",
    function (value, element) {
        // 如果欄位為空，讓 required 規則處理
        if (!value || value.trim() === "") {
            return true;
        }
        return window.validatePassword(value);
    },
    "密碼必須為 8 至 20 個字元，且須包含英文大小寫及數字"
);

// 添加字串比對驗證規則 (比對兩個欄位的值是否相同)
$.validator.addMethod(
    "matchWith",
    function (value, element, param) {
        // 如果欄位為空，讓 required 規則處理
        if (!value || value.trim() === "") {
            return true;
        }
        
        // 取得要比對的目標欄位
        var target = $(param);
        
        // 綁定目標欄位的 blur 事件，當目標欄位更新時重新驗證當前欄位
        if (target.not(".validate-matchWith-blur").length) {
            target.addClass("validate-matchWith-blur").on("blur.validate-matchWith", function() {
                $(element).valid();
            });
        }
        
        // 比對兩個欄位的值
        return value === target.val();
    },
    "兩個欄位的值不一致"
);

$.validator.setDefaults({
    showErrors: function (map, errorList) {
        // there's probably a way to simplify this
        let focussed = document.activeElement;

        if (focussed) {
            const rdRequired = $(focussed).closest(".rd-show-validator-error");

            // 因為這裡取不到 select 的 focus 所以只能把 select 的事件寫在下面
            if (
                $(focussed).is("input, textarea") &&
                rdRequired.find(".rd-notice").length > 0
            ) {
                rdRequired.find(".rd-notice").remove();
                $(focussed).css("border", "1px solid #ddd");
            }
        }

        $.each(errorList, function (index, error) {
            let element = error.element;
            let target = $(element).closest(".rd-show-validator-error");

            if ($(element).is("input,textarea")) {
                if ($(target).find(".rd-notice").length > 0) {
                    $(target).find(".rd-notice").remove();
                    $(element).css("border", "1px solid #ddd");
                }
                $(element).css("border", "1px solid #dc3545");
            } else if ($(element).is("select")) {
                if ($(target).find(".rd-notice").length > 0) {
                    $(target).find(".rd-notice").remove();
                    $(element)
                        .closest(".rd-required")
                        .find("select")
                        .css("border", "1px solid #ddd");
                }
                $(element)
                    .closest(".rd-required")
                    .find("select")
                    .css("border", "1px solid #dc3545");
                // 要綁定移除錯誤的事件
                $(element).on("change", function () {
                    if ($(this).val() !== "") {
                        $(this)
                            .closest(".rd-required")
                            .find(".rd-notice")
                            .remove();
                        $(this)
                            .closest(".rd-required")
                            .find("select")
                            .css("border", "1px solid #ddd");
                    }
                });
            }
            $(target).append(
                '<div class="rd-notice" style="width: 100%;margin-top: .25rem;font-size: 80%;color: #dc3545;">' +
                    error.message +
                    "</div>"
            );
        });
    },
    invalidHandler: function (event, validator) {
       
        //若無錯誤則跳過以下步驟
        if (!validator.numberOfInvalids()) return;

        // 以Class「rd-required」為基準，作為捲軸移動參考
        let obj = $(validator.errorList[0].element);

        console.log(obj)
        console.log(obj.closest(".rd-required"))
        let top = obj.closest(".rd-required").offset().top;

        let header = $('#rd-header').outerHeight()+120;

        $("html,body").animate(
            {
                scrollTop: top-header,
            },
            500
        );
    },
});

$.validator.addMethod("synchronousRemote", function (value, element, param) {
    if (this.optional(element)) {
        return "dependency-mismatch";
    }

    var previous = this.previousValue(element);
    if (!this.settings.messages[element.name]) {
        this.settings.messages[element.name] = {};
    }
    previous.originalMessage = this.settings.messages[element.name].remote;
    this.settings.messages[element.name].remote = previous.message;

    param = typeof param === "string" && { url: param } || param;

    if (previous.old === value) {
        return previous.valid;
    }
    
    const token = $('meta[name="_csrf_token"]').attr('content');

    previous.old = value;
    var validator = this;
    this.startRequest(element);
    var data = {};
    data[element.name] = value;
    var valid = "pending";
    $.ajax($.extend(true, {
        url: param,
        async: false,
        mode: "abort",
        port: "validate" + element.name,
        dataType: "json",
        data: data,
        headers: {
            'RequestVerificationToken': token
        },
        success: function (response) {
            validator.settings.messages[element.name].remote = previous.originalMessage;
            valid = response === true || response === "true";
            if (valid) {
                var submitted = validator.formSubmitted;
                validator.prepareElement(element);
                validator.formSubmitted = submitted;
                validator.successList.push(element);
                delete validator.invalid[element.name];
                validator.showErrors();
            } else {
                var errors = {};
                var message = response || validator.defaultMessage(element, "remote");
                errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
                validator.invalid[element.name] = true;
                validator.showErrors(errors);
            }
            previous.valid = valid;
            validator.stopRequest(element, valid);
        }
    }, param));
    return valid;
}, "Please fix this field.");

$.validator.addMethod("filesize", function (value, element, param) {
    if (element.files.length === 0) return true;
    return element.files[0].size <= param * 1024 * 1024;
}, "檔案大小超過限制");

$.validator.addMethod("dateYMD", function (value, element) {
    if (this.optional(element)) return true;

    // YYYY-MM-DD
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(value)) return false;

    const date = new Date(value);
    return !isNaN(date.getTime());
}, "請輸入正確的日期格式 (YYYY-MM-DD)");